export const BRAND = {
  name: "PrimeCore Solutions Pvt. Ltd.",
  product: "Q-Wis",
  tagline: "Wisdom on Quality & Sustainability",
  domain: "pcoresolution.com",
  logos: {
    primecore:
      "https://customer-assets.emergentagent.com/job_launch-qwis/artifacts/bo4kwt4n_PrimeCore%20Logo%20for%20Mail.jpg",
    qwis:
      "https://customer-assets.emergentagent.com/job_launch-qwis/artifacts/kx1v5evj_Logo%20for%20Desktop.png",
  },
};

export const IMAGES = {
  hero_factory:
    "https://images.unsplash.com/photo-1727517786847-7a409bde2add?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxjbG90aGluZyUyMGZhY3RvcnklMjB3b3JrZXJzfGVufDB8fHx8MTc3ODI5MjY4M3ww&ixlib=rb-4.1.0&q=85",
  quality_inspection:
    "https://images.unsplash.com/photo-1770196009760-bead9eb10514?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxxdWFsaXR5JTIwaW5zcGVjdGlvbiUyMGZhYnJpY3xlbnwwfHx8fDE3NzgyOTI2ODN8MA&ixlib=rb-4.1.0&q=85",
  textile:
    "https://images.unsplash.com/photo-1758272024360-a95be2abe403?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHx0ZXh0aWxlJTIwbWFudWZhY3R1cmluZ3xlbnwwfHx8fDE3NzgyOTI2ODN8MA&ixlib=rb-4.1.0&q=85",
  machine:
    "https://images.unsplash.com/photo-1772351721310-0aa6b2d5ee49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxxdWFsaXR5JTIwaW5zcGVjdGlvbiUyMGZhYnJpY3xlbnwwfHx8fDE3NzgyOTI2ODN8MA&ixlib=rb-4.1.0&q=85",
};

export const MODULES = [
  {
    id: "product-quality",
    name: "Product Inspection Module",
    short: "Know Your Product",
    description:
      "Accommodates any inspections from RM to Final — Final Inspection, RM Inspection, and AQL audits in real-time.",
    bullets: [
      "Macro and detailed reports drilling into SBU, Plant, Process, Section, Line, Customer, Style and defects at each operation.",
      "Defects captured against the operation they came from — so problem solving happens at the point of occurrence.",
      "Tracks defect migration across processes so you know exactly where to focus improvement effort.",
      "Works real-time on the floor or via data entry — at the lowest investment.",
    ],
  },
  {
    id: "process-compliance",
    name: "Process & Compliance Audit Module",
    short: "Know Your Processes",
    description:
      "Configurable to any checklist — customer or internal. Recording, scoring, and digital proof in real-time.",
    bullets: [
      "Scoring based on customer, internal or sustainability standards with a clear ownership matrix.",
      "Process & owner-level KPIs including CAP% — corrective action submission for every shortfall.",
      "Macro and micro analysis to evaluate the health of your processes and your suppliers'.",
      "Flexible configuration of any process, compliance or sustainability checklist.",
    ],
  },
  {
    id: "rca",
    name: "Systematic Problem Solving Module (CAP / PDCA)",
    short: "Continuous Improvement",
    description:
      "A real-time problem-solving platform. Build a library of problems, root causes and actions so issues don't recur.",
    bullets: [
      "Structured PDCA / CAP workflow — follow the steps in the system, you can't go wrong.",
      "Your own knowledge library, stacked by defects, operations and KPI shortfalls for efficient sharing.",
      "Track plans with owners, due dates and progress updates.",
      "Aligned with the requirements of global apparel brands.",
    ],
  },
  {
    id: "actions",
    name: "Action Plans & Governance Module",
    short: "Governance at Your Fingertips",
    description:
      "Track actions, status, and management efficiency by department and owner.",
    bullets: [
      "Forum & meeting efficiency with action completion at department and individual level.",
      "Monitor management efficiency in problem-solving and improvement — not just opinions.",
      "Project status and governance at your fingertips, from anywhere.",
      "Insightful reports for business sustainability, accountability and follow-through.",
    ],
  },
];

export const MODULE_REPORTS = {
  "product-quality": {
    moduleName: "Product Inspection Module",
    tagline: "From macro numbers to the trend curve — a single audit summary that drills all the way down.",
    stories: [
      {
        title: "Total Audit Summary",
        subtitle: "Table → Bar Chart → Trend",
        note: "Visualise your inspection data in a snapshot table, then switch to bar charts to compare stages side-by-side, or trend charts to see the progress over time — all from one screen.",
        steps: [
          {
            step: "01",
            action: "Table",
            src: "/reports/pi-table.png",
            caption: "Every audit, defect rate and defective rate across every inspection stage — one screen, one truth.",
          },
          {
            step: "02",
            action: "Bar Chart",
            src: "/reports/pi-bar.png",
            caption: "Compare inspection stages at a glance. The spike jumps out — you see exactly where to act, today.",
          },
          {
            step: "03",
            action: "Trend",
            src: "/reports/pi-trend.png",
            caption: "Progress over time — week by week. Did your corrective actions actually work? The curve tells you.",
          },
        ],
      },
      {
        title: "KPI Correlation",
        subtitle: "Table → Bar Chart → Trend",
        note: "Compare KPIs across Plant, Section, Module, Owner or Machine — so you can direct focus and accountability to the exact organisational level that needs it.",
        steps: [
          {
            step: "01",
            action: "Table",
            src: "/reports/pi-kpi-table.png",
            caption: "Every module, section and owner side-by-side — audits, pass rate and defect rate against your chosen KPI.",
          },
          {
            step: "02",
            action: "Bar Chart",
            src: "/reports/pi-kpi-bar.png",
            caption: "Rank plants, modules or owners in one glance. The under-performer is impossible to miss.",
          },
          {
            step: "03",
            action: "Trend",
            src: "/reports/pi-kpi-trend.png",
            caption: "Track any single module, machine or owner over time — accountability that keeps improving.",
          },
        ],
      },
      {
        title: "Defect Origin — where did it come from?",
        subtitle: "Top Defect → Origin List → Bar Chart → Trend",
        note: "Starting from a top defect, drill straight into the exact operation that produced it — then see it as a table, a bar chart, or a trend of that specific operation over time. Problem solving at the point of occurrence, not in a meeting room.",
        steps: [
          {
            step: "01",
            action: "Top Defects",
            src: "/reports/pi-def-table.png",
            caption: "Every defect ranked by quantity and %, across Visual, Measurement and Packing. Your top few defects are impossible to hide.",
          },
          {
            step: "02",
            action: "Origin List",
            src: "/reports/pi-origin-bar.png",
            caption: "Pick any defect (e.g. Dropped Stitch) — Q-Wis shows the exact operations it originated from, in a table you can act on.",
          },
          {
            step: "03",
            action: "Origin Bar Chart",
            src: "/reports/pi-origin-trend.png",
            caption: "The offending operation jumps out — no more finger-pointing, just facts.",
          },
          {
            step: "04",
            action: "Origin Trend",
            src: "/reports/pi-origin-list.png",
            caption: "Track that specific operation over time — did your countermeasures actually reduce the defect at source?",
          },
        ],
      },
      {
        title: "Defect Distribution — how did it migrate?",
        subtitle: "Top Defect → Distribution List → Distribution Bar Chart",
        note: "See a single defect (e.g. Dropped Stitch) tracked across every inspection stage — from Yarn Inspection all the way to 3rd-Party Final. It shows how effectively your quality process is stopping the defect at source, instead of letting it slip down the value chain.",
        steps: [
          {
            step: "01",
            action: "Top Defects",
            src: "/reports/pi-def-table.png",
            caption: "Same starting point as origin analysis — but now we ask a different question: how far along the value chain is this defect leaking?",
          },
          {
            step: "02",
            action: "Distribution List",
            src: "/reports/pi-dist-list.png",
            caption: "The defect tracked across every inspection stage — inspected qty, defects and defect % at each stage, in one clean table.",
          },
          {
            step: "03",
            action: "Distribution Bar Chart",
            src: "/reports/pi-dist-bar.png",
            caption: "See where the defect is being caught and where it's slipping through — a picture that instantly shows the effectiveness of your quality process.",
          },
        ],
      },
    ],
    additionalReports: [
      {
        title: "Supplier Performance",
        d: "Same table → bar chart → trend visualisations, applied to every supplier — so you know exactly whose material is costing you.",
      },
      {
        title: "Re-Work",
        d: "See re-work at every level — inspection stage, manufacturing process and plant — to quantify the hidden cost of failure that never leaves the floor.",
      },
      {
        title: "Individual Inspection Report",
        d: "Drill all the way down to a single audit — with defect digitals (photos) captured on the spot, so nothing gets lost in translation.",
      },
      {
        title: "Excel Dumps for Further Analysis",
        d: "One-click export of any table or drill-down to Excel — take the data wherever your team needs it.",
      },
    ],
  },
  "process-compliance": {
    moduleName: "Process & Compliance Audit Module",
    tagline: "See audit status, scores and CAP submission — from cluster all the way down to a single owner.",
    stories: [
      {
        title: "Location Level Status",
        subtitle: "Table → Bar Chart → Trend",
        note: "See audit status across your locations — cluster, plant or section. Check-points marked 'Good', the score achieved (allocation vs. achievement), and CAP / PDCA submission on every shortfall. Compare with bar charts, or track progress with trend charts.",
        steps: [
          {
            step: "01",
            action: "Table",
            src: "/reports/pc-loc-table.png",
            caption: "Every plant side-by-side — check-points, score % and CAP status in a single view. Cluster it, filter it, act on it.",
          },
          {
            step: "02",
            action: "Bar Chart",
            src: "/reports/pc-loc-bar.png",
            caption: "Compare score % across plants at a glance. The gap between top and bottom performers is instantly visible.",
          },
          {
            step: "03",
            action: "Trend",
            src: "/reports/pc-loc-trend.png",
            caption: "Track a plant's score over time — is compliance actually improving, or just holding on?",
          },
        ],
      },
      {
        title: "Process / Owner Level Status",
        subtitle: "Process View → Owner View",
        note: "Same audit story — but sliced by manufacturing process or by owner (department). See exactly which process is dragging the score down, and which owner is on top of their CAP submissions. Compare with bar charts, or track with trend charts.",
        steps: [
          {
            step: "01",
            action: "Process View",
            src: "/reports/pc-proc-table.png",
            caption: "Every process — Embroidery, Cutting, Sewing, Finishing and more — with check-points, score % and CAP % in one clean table.",
          },
          {
            step: "02",
            action: "Owner View",
            src: "/reports/pc-owner-table.png",
            caption: "Same view, sliced by owner department — Quality, Maintenance, Operations, H&S — so accountability is unambiguous.",
          },
        ],
      },
    ],
    additionalReports: [
      {
        title: "Individual Audit Report",
        d: "Drill down to a single audit with scoring and proof digitals — the exact photo evidence from the floor, attached to the check-point.",
      },
      {
        title: "Excel Dumps for Further Analysis",
        d: "One-click export of any table or drill-down to Excel — take the data wherever your team needs it.",
      },
    ],
  },
  "rca": {
    moduleName: "Systematic Problem Solving Module (CAP / PDCA)",
    tagline: "Stop re-inventing the wheel. Build your own library of expertise, and dig deep on every problem worth solving.",
    stories: [
      {
        title: "Your Own Library of Expertise",
        subtitle: "Categorised by Defect, Process Shortfall, KPI Shortfall or 5M Waste",
        note: "Every problem your team has ever solved — captured, categorised and instantly searchable. So the next time it recurs at another line, plant or supplier, you don't reinvent the wheel: you reuse the solution.",
        steps: [
          {
            step: "01",
            action: "PDCA Summary",
            src: "/reports/ps-library.png",
            caption: "Filter by defect, defect origin, process shortfall, KPI shortfall or 5M waste — see every PDCA on record with a count of how often each has been solved.",
          },
        ],
      },
      {
        title: "Individual Problem-Solving Report",
        subtitle: "Problem → Root Cause → Actions — one full report",
        note: "The full 8D-style story of a single problem in one document: the problem statement, potential causes, root-cause analysis (5-Whys), and the actions with owners, due dates and status. Every decision, every learning — locked in.",
        steps: [
          {
            step: "01",
            action: "Full Problem-Solving Report",
            srcs: [
              "/reports/ps-report-1.png",
              "/reports/ps-report-2.png",
              "/reports/ps-report-3.png",
            ],
            combinedHref: "/reports/ps-report-combined.png",
            caption: "Header, potential-causes analysis and action plan — all in one referenceable report. Nothing lost, nothing forgotten.",
          },
        ],
      },
    ],
    additionalReports: [
      {
        title: "Excel Dumps for Further Analysis",
        d: "One-click export of every PDCA in the library to Excel — for offline analysis, sharing, or building your own dashboards.",
      },
    ],
  },
  "actions": {
    moduleName: "Action Plans & Governance Module",
    tagline: "See if your management is actually delivering — or just talking about it.",
    stories: [
      {
        title: "Management Efficiency on Action Delivery",
        subtitle: "Table → Bar Chart",
        note: "See how effectively actions are being delivered — sliced by Department, Action Owner, Forum or Action Type. Beyond individual and departmental progress, get a clear view of how productively each meeting and forum contributes, so leadership can continue to support the effectiveness and efficiency of the core product.",
        steps: [
          {
            step: "01",
            action: "Table",
            src: "/reports/ag-table.png",
            caption: "Every owner side-by-side — Completed, In-Progress, On Time, Delayed and Delay % by count and by days. Accountability that's impossible to hide from.",
          },
          {
            step: "02",
            action: "Bar Chart",
            src: "/reports/ag-bar.png",
            caption: "Rank owners on delay % at a glance. The management-efficiency conversation is now backed by data, not opinion.",
          },
        ],
      },
    ],
    additionalReports: [
      {
        title: "Excel Dumps for Further Analysis",
        d: "One-click export of every action log to Excel — for offline analysis, sharing, or building your own governance dashboards.",
      },
    ],
  },
};

export const FOUNDERS = [
  {
    name: "Suresh Weerasinghe",
    role: "Co-Founder · Quality Strategy",
    bio: "Former Group Head of Quality (1990–2022) at a premier Sri Lankan apparel exporter with global manufacturing footprint. Three decades of QA leadership across diverse product categories.",
    email: "sureshw@pcoresolution.com",
    phone: "+94 (0) 777353780",
    whatsapp: "+94777353780",
  },
  {
    name: "Lasith Nandasena",
    role: "Co-Founder · Quality Digitalization",
    bio: "Former Group QA Analyst, Quality Digitalization (2009–2025). Specialist in translating quality systems into digital, scalable, real-time solutions for manufacturing.",
    email: "lasithn@pcoresolution.com",
    phone: "+94 (0) 773965554",
    whatsapp: "+94773965554",
  },
  {
    name: "Vijitha Gangodavila",
    role: "Technical Lead · Product & Engineering",
    bio: "Former Development Lead (2012–2019) and Consultant (2020–2025). Deep IT expertise in building robust enterprise software for the apparel industry.",
    email: "",
    phone: "",
    whatsapp: "",
  },
];

export const CONTACT = {
  generalEmail: "info@pcoresolution.com",
  offices: [
    {
      country: "Sri Lanka",
      label: "Registered Office — Sri Lanka",
    },
    {
      country: "Bangladesh",
      label: "Registered Office — Bangladesh",
    },
  ],
};
